import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

// Importing icons...
import ReplayIcon from '@mui/icons-material/Replay';
import LocalShipping from '@mui/icons-material/LocalShipping';
import SettingsIcon from '@mui/icons-material/Settings';
import BuildIcon from '@mui/icons-material/Build';
import SyncIcon from '@mui/icons-material/Sync';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SearchIcon from '@mui/icons-material/Search';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffSharp from '@mui/icons-material/VisibilityOffSharp';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import TurnedInNotIcon from '@mui/icons-material/TurnedInNot';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import MuiInfoIcon from '@mui/icons-material/Info';
// import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'; // * These carrot icons have been updated to match the global desing spec.
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'; // ** See CarrotUpIcon && CarrotDownIcon for the updated versions.

import ErrorIcon from '@mui/icons-material/Error';
import Warning from '@mui/icons-material/Warning';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import FilterListIcon from '@mui/icons-material/FilterList';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LinkIcon from '@mui/icons-material/Link';
import MailOutline from '@mui/icons-material/MailOutline';

import RoomIcon from '@mui/icons-material/Room';
// 360 icon not found in icons-material

import MenuIcon from '@mui/icons-material/Menu';
import AppsIcon from '@mui/icons-material/Apps';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ClearIcon from '@mui/icons-material/Clear';
import CancelIcon from '@mui/icons-material/Cancel';
import CachedIcon from '@mui/icons-material/Cached';
import LogoutIcon from '@mui/icons-material/Logout';
import CreditCard from '@mui/icons-material/CreditCard';

// Don't kmow what icon is that
import ShareIcon from '@mui/icons-material/Share';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import NotificationsIcon from '@mui/icons-material/Notifications';

import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import UserIcon from '@mui/icons-material/AccountCircleOutlined';
import CloseCircleOutlineIcon from './close-circle-outline-icon';
import CloseCircleSolidIcon from './close-circle-solid-icon';
import CloseIcon from './close-icon';
import CloseSmallIcon from './close-small-icon';
import CartIcon from './cart';
import FacebookWhite from './facebook-white';
import DesktopTower from '../profile/DesktopTower';
import RocketIcon from './rocket-icon';
import AttachmentIcon from './attachment-icon';
import TrashIcon from './trash-icon';
import SupportIcon from './support';
import SupportAgentIcon from './support-agent-icon';
import SupportUserIcon from './support-user-icon';
import ArrowUpIcon from './arrow-up-icon';
import ArrowDownIcon from './arrow-down-icon';
import ChevronUpIcon from './chevron-up-icon';
import ChevronUpSmallIcon from './chevron-up-small-icon';
import ChevronDownIcon from './chevron-down-icon';
import ChevronDownSmallIcon from './chevron-down-small-icon';
import ChevronLeftIcon from './chevron-left-icon';
import ChevronLeftSmallIcon from './chevron-left-small-icon';
import ChevronRightIcon from './chevron-right-icon';
import ChevronRightSmallIcon from './chevron-right-small-icon';
import InfoIcon from './info-icon';
import InfoOutlineIcon from './info-outline-icon';
import AccountIcon from './account';
import ExitIcon from './exit';
import ErrorHPID from './error-hpid';
import SpinnerIcon from './spinner';
import XCircleIcon from './xcircle';
import ThreeHundredSixtyIcon from './360-icon';
import EyeOutlineIcon from './eye-outline-icon';
import EyeSlashOutlineIcon from './eye-slash-outline-icon';
import EyeClosedIcon from './eye-closed-icon';
import UserOutlineIcon from './user-outline-icon';
import AttachmentSmallIcon from './attachment-small-icon';
import FederatedLoginGoogleIcon from './federated-login-google-icon';
import FederatedLoginFacebookIcon from './federated-login-facebook-icon';
import FederatedLoginMicrosoftIcon from './federated-login-microsoft-icon';

const actionIconsMap = {
  exit: <ExitIcon />,
  settings: <SettingsIcon />,
  build: <BuildIcon />,
  sync: <SyncIcon />,
  favorite: <FavoriteIcon />,
  'check-circle-full': <CheckCircleIcon />,
  search: <SearchIcon />,
  eye: <RemoveRedEyeIcon />,
  'visibility-off': <VisibilityOffSharp />,
  'bookmark-full': <BookmarkIcon />,
  'bookmark-empty': <TurnedInNotIcon />,
  'drag-handle': <DragHandleIcon />,
  check: <CheckIcon />,
  'check-circle-empty': <CheckCircleOutlineIcon />,
  cached: <CachedIcon />,
  user: <UserIcon />,
  'support-agent': <SupportAgentIcon />,
  'support-user': <SupportUserIcon />,
  spinner: <SpinnerIcon />,
  xcircle: <XCircleIcon />,
};

const federatedAccounts = {
  google: <FederatedLoginGoogleIcon />,
  facebook: <FederatedLoginFacebookIcon />,
  microsoft: <FederatedLoginMicrosoftIcon />,
};

const notificationIconsMap = {
  error: <ErrorIcon />,
  'error-outline': <ErrorOutlineIcon />,
  warning: <Warning />,
  errorHPID: <ErrorHPID />,
  info: <InfoIcon />,
  'info-outline': <InfoOutlineIcon />,
  'mui-info': <MuiInfoIcon />,
};

const contentIconsMap = {
  copy: <ContentCopyIcon />,
  add: <AddIcon />,
  edit: <EditIcon />,
  filter: <FilterListIcon />,
  calendar: <CalendarTodayIcon />,
  link: <LinkIcon />,
  'desktop-tower': <DesktopTower />,
};

const mapIconsMap = {
  pin: <RoomIcon />,
  '360': <ThreeHundredSixtyIcon />,
};

const navigationIconsMap = {
  menu: <MenuIcon />,
  apps: <AppsIcon />,
  'full-screen': <FullscreenIcon />,
  'full-screen-exit': <FullscreenExitIcon />,
  'more-horizontal': <MoreHorizIcon />,
  'more-vertical': <MoreVertIcon />,
  'arrow-up': <ArrowUpIcon />,
  'arrow-down': <ArrowDownIcon />,
  'arrow-left': <ArrowLeftIcon />,
  'arrow-right': <ArrowRightIcon />,
  'chevron-up': <ChevronUpIcon />,
  'chevron-up-small': <ChevronUpSmallIcon />,
  'chevron-down': <ChevronDownIcon />,
  'chevron-down-small': <ChevronDownSmallIcon />,
  'chevron-left': <ChevronLeftIcon />,
  'chevron-left-small': <ChevronLeftSmallIcon />,
  'chevron-right': <ChevronRightIcon />,
  'chevron-right-small': <ChevronRightSmallIcon />,
  clear: <ClearIcon />,
  cancel: <CancelIcon />,
};

const socialIconsMap = {
  share: <ShareIcon />,
  'notification-none': <NotificationsNoneIcon />,
  notification: <NotificationsIcon />,
  'facebook-white': <FacebookWhite />,
};

const toggleIconsMap = {
  star: <StarIcon />,
  'star-half': <StarHalfIcon />,
  'star-outline': <StarOutlineIcon />,
};

const utilityIconsMap = {
  'eye-outline': <EyeOutlineIcon />,
  'eye-slash-outline': <EyeSlashOutlineIcon />,
  'eye-closed': <EyeClosedIcon />,
  'user-outline': <UserOutlineIcon />,
  rocket: <RocketIcon />,
  trash: <TrashIcon />,
  paperclip: <AttachmentIcon />,
  'paperclip-small': <AttachmentSmallIcon />,
  cart: <CartIcon />,
  account: <AccountIcon />,
  support: <SupportIcon />,
  logout: <LogoutIcon />,
  'close-circle-outline': <CloseCircleOutlineIcon />,
  'close-circle-solid': <CloseCircleSolidIcon />,
  close: <CloseIcon />,
  'close-small': <CloseSmallIcon />,
  'mail-outline': <MailOutline />,
  'replay': <ReplayIcon />,
  'local-shipping': <LocalShipping />,
  'credit-card': <CreditCard />
};

const iconsMap = {
  ...actionIconsMap,
  ...notificationIconsMap,
  ...contentIconsMap,
  ...mapIconsMap,
  ...navigationIconsMap,
  ...socialIconsMap,
  ...toggleIconsMap,
  ...utilityIconsMap,
  ...federatedAccounts,
};

export type IconName = keyof typeof iconsMap;

export type IconProps = Omit<SvgIconProps, 'children'> & {
  size?: 'large' | 'medium' | 'small' | string;
  color?: string;
  children?: React.ReactNode;
  iconName?: IconName;
  sx?: object;
};

export const Icon: React.FC<IconProps> = ({
  size = 'medium',
  color,
  children,
  iconName,
  sx,
  ...props
}) => {
  const htmlColor = color || 'rgba(0, 0, 0, 0.75);';
  const fontSize =
    {
      small: '12px',
      medium: '24px',
      large: '48px',
    }[size] ?? size;

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const icon = iconName ? iconsMap[iconName!] : children;

  return (
    <SvgIcon htmlColor={htmlColor} sx={{ ...sx, fontSize }} {...props}>
      {icon}
    </SvgIcon>
  );
};

export default Icon;
